import { ADD_REQUEST, UPDATE_REQUEST, DELETE_REQUEST } from 'app/redux/actions';

const initialState = {
  requests: [],
};

const requestReducer = (state = initialState, action) => {
  switch (action.type) {
    case ADD_REQUEST:
      return {
        ...state,
        requests: [...state.requests, action.payload],
      };
    case UPDATE_REQUEST:
      return {
        ...state,
        requests: state.requests.map((request) =>
          request.id === action.payload.id ? { ...request, ...action.payload } : request
        ),
      };
    case DELETE_REQUEST:
      return {
        ...state,
        requests: state.requests.filter((request) => request.id !== action.payload),
      };
    default:
      return state;
  }
};

export default requestReducer;
